import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, useLocation } from 'react-router-dom'
import { Onetrust } from '@calendly/onetrust/redux'

import { isPollSelector } from 'selectors/event_type'
import ErrorGuard from 'components/error/guard'
import { shouldHideOnetrustSelector } from 'selectors/gdpr'
import { useOnetrust } from 'components/use_onetrust'


const OnetrustWrapper = () => {
  const onetrust = useOnetrust()
  const isEnabled = !useSelector(shouldHideOnetrustSelector)

  if (!onetrust) return null

  return (
    <Onetrust
      isEnabled={isEnabled}
      domainScript={onetrust.data_domain_script}
      hide={onetrust.hide}
    />
  )
}

const BookingRoute = ({ ...props }) => {
  const isPoll = useSelector(isPollSelector)
  const location = useLocation()

  useEffect(() => {
    if (!isPoll) {
      window.scrollTo(0, 0)
    }
  }, [isPoll, location.pathname, location.search])

  return (
    <Route {...props}>
      <OnetrustWrapper />
      <ErrorGuard>
        {props.children}
      </ErrorGuard>
    </Route>
  )
}

export default BookingRoute
